import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Sparkles, Target, HeartHandshake, MessageCircle } from 'lucide-react';
const FOR_WHO = ['Padres latinos en USA que viven con el estrés del trabajo y poco tiempo libre.', 'Mamás y papás que sienten que han perdido la autoridad en su propia casa.', 'Familias que quieren criar con respeto pero que no creen en la permisividad total.', 'Padres con niños que parecen tener "sordera selectiva" ante las órdenes diarias.'];
const NOT_FOR_WHO = ['Personas que creen que la única forma de educar es mediante el castigo físico.', 'Padres que buscan una solución mágica que no requiera cambiar su forma de hablar.', 'Quienes no están dispuestos a dedicar 5 minutos a leer cómo funciona el cerebro de sus hijos.'];
const STEPS = [{
  icon: Target,
  title: "Entiende el 'Por Qué'",
  desc: 'Descubre qué pasa en el cerebro de tu hijo según su edad.'
}, {
  icon: MessageCircle,
  title: 'Cambia el Guion',
  desc: 'Aplica las frases cortas y efectivas del manual en lugar de repetir órdenes largas.'
}, {
  icon: HeartHandshake,
  title: 'Recupera la Calma',
  desc: 'Observa cómo la resistencia disminuye y tu nivel de estrés baja drásticamente.'
}];
export function FitSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-13">
      <div className="max-w-5xl mx-auto px-6" data-id="element-14">
        {/* Who is this for */}
        <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-sage-50 rounded-3xl p-8 border border-sage-100" data-id="element-16">
            <h3 className="font-serif text-2xl text-navy mb-6 flex items-center gap-2" data-id="element-17">
              <Check className="text-sage-600 w-6 h-6" data-id="element-18" />
              Esto ES para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-19">
              {FOR_WHO.map((item, i) => <li key={i} className="flex gap-3 text-stone-700" data-id="element-20">
                  <div className="w-1.5 h-1.5 rounded-full bg-sage-400 shrink-0 mt-2" data-id="element-21" />
                  <span data-id="element-22">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-stone-50 rounded-3xl p-8 border border-stone-200" data-id="element-23">
            <h3 className="font-serif text-2xl text-navy mb-6 flex items-center gap-2" data-id="element-24">
              <X className="text-stone-400 w-6 h-6" data-id="element-25" />
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-26">
              {NOT_FOR_WHO.map((item, i) => <li key={i} className="flex gap-3 text-stone-600" data-id="element-27">
                  <div className="w-1.5 h-1.5 rounded-full bg-stone-300 shrink-0 mt-2" data-id="element-28" />
                  <span data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* How it works */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-30">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-12 text-center" data-id="element-31">
            ¿Cómo funciona?
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-32">
            {STEPS.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} className="text-center relative" data-id="element-33">
                  {i !== STEPS.length - 1 && <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-[2px] bg-sage-100" data-id="element-34" />}
                  <div className="w-16 h-16 mx-auto bg-sage-100 text-sage-700 rounded-full flex items-center justify-center mb-6 relative z-10" data-id="element-35">
                    <Icon className="w-8 h-8" data-id="element-36" />
                  </div>
                  <h4 className="font-bold text-xl text-navy mb-3" data-id="element-37">
                    {step.title}
                  </h4>
                  <p className="text-stone-600" data-id="element-38">{step.desc}</p>
                </div>;
          })}
          </div>
        </motion.div>

        {/* Proof / Believability */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-amber-50 rounded-3xl p-8 md:p-12 text-center border border-amber-100" data-id="element-39">
          <Sparkles className="w-10 h-10 text-amber-500 mx-auto mb-6" data-id="element-40" />
          <h3 className="font-serif text-2xl md:text-3xl text-navy mb-4" data-id="element-41">
            Lo que cambia en 7 días
          </h3>
          <p className="text-lg md:text-xl text-stone-700 max-w-2xl mx-auto leading-relaxed" data-id="element-42">
            Pasarás de repetir "ponte los zapatos" siete veces con un grito
            final, a usar una <strong data-id="element-43">opción limitada de 3 segundos</strong> que
            logra que tu hijo se calce solo mientras tú terminas de preparar el
            café. No es magia, es comunicación alineada con el desarrollo
            infantil.
          </p>
        </motion.div>
      </div>
    </section>;
}